// extracted by mini-css-extract-plugin
export var actions = "_1e-0";
export var actionsContainer = "_1e-6";
export var border = "_1e-1";
export var childFullHeight = "_1e-d";
export var collapse = "_1e-2";
export var content = "_1e-8";
export var contentChild = "_1e-c";
export var fullscreen = "_1e-a";
export var headerContainer = "_1e-3";
export var headerRow = "_1e-5";
export var hidePadding = "_1e-9";
export var noScrollX = "_1e-e";
export var noScrollY = "_1e-f";
export var optOutTopPadding = "_1e-b";
export var pagePadding = "_1e-7";
export var profile = "_1e-g";
export var profileContainer = "_1e-h";
export var profileImage = "_1e-i";
export var profileMain = "_1e-j";
export var profileSubtitle = "_1e-l";
export var profileTitle = "_1e-k";
export var tabsWrapper = "_1e-4";
export var title = "_1e-m";